<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Privacy Policy</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Privacy Policy</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <button class="btn btn-info" @click="goback()">
                  <!-- <i class="fa fa-filter"></i> -->
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- <h3></h3> -->
          <p>
            Protecting our customers’ privacy is an important priority at
            Carnival and we are committed to maintaining h3 and meaningful
            privacy protections. The privacy of your information is a
            significant responsibility and we value the trust you place in us.
            Our Privacy Policy is designed to inform you about the information
            we collect, how we use it, and your options regarding certain uses
            of this information. This policy applies to all website visitors,
            app users, customers, buyers and users (collectively called as
            "Users"). In addition, this Privacy Policy applies to all products
            and services provided by Carnival. By accepting the Privacy Policy
            and the Terms & Conditions during registration, you expressly
            consent to our collection, storage, use and disclosure of your
            personal information as described in this Privacy Policy.
          </p>
        </div>

        <div class="row">
          <h4>Information we collect and how it is used</h4>
          <p>
            We collect information when you communicate with us and when you use
            our products, services and sites. This includes information you
            provide such as name and contact information, images, voice
            recordings or prints, the reason for contacting us and payment
            information. Service usage information we collect includes call
            records, websites visited and network traffic data, product and
            device-specific information and identifiers, service options you
            choose. Usage and other similar information. We use this information
            to establish, monitor and maintain your account and billing records;
            measure credit and payment risk; provide account-related services;
            deliver and maintain your products and services; help you with
            service-related issues or questions; manage and protect our
            networks, services and users from fraudulent, abusive, or unlawful
            uses; help us improve our services and research and develop new
            products and services; authenticate you; determine your eligibility
            for new products and services and contact you with marketing offers.
            When you contact us or we contact you, we may monitor or record that
            communication or keep a record of the transaction to help us train
            employees and better serve you. We may automatically measure and
            monitor network performance and the performance of your connections
            to improve your, or our, service levels and products. If you contact
            us for service support, we also may access information about your
            computer or other device settings to provide customized technical
            support or to install specific applications or services that you use
            or that are necessary to the applications or services you use. When
            you establish an online account or register on our sites or apps, we
            may collect information about your user identification, password and
            secret questions and answers. We use this information to
            authenticate you when you sign in.
          </p>
        </div>
        <div class="row">
          <h4>Information provided to or used by third-party advertisers</h4>
          <p>
            Carnival obtains information from outside companies such as those
            that collect consumer information including demographic and interest
            data. We use this data and combine it with other information to
            direct marketing offers that might be more relevant to you, and to
            help us better analyze customer information for various purposes. We
            also obtain contact information and other marketing lead information
            from third parties, website “refer-a-friend” options or social media
            platforms and may combine it with information to contact you or
            direct marketing offers to you.
          </p>
        </div>

        <div class="row">
          <h4>Information shared</h4>
          <p>
            Carnival uses vendors and partners for a variety of business
            purposes such as to help us offer, provide, repair, restore and bill
            for services we provide. We share information with those vendors and
            partners when it is necessary for them to perform work on our
            behalf. For example, we may provide your credit card information and
            billing address to our payment processing company solely for
            processing payment for a transaction you have requested. We require
            that these vendors and partners protect the customer information we
            provide to them and limit their use of Carnival customer data to the
            purposes for which it was provided. We do not permit these types of
            vendors and partners to use this information for their own marketing
            purposes. Carnival also may share certain information with outside
            companies, for example, to assist with the delivery of advertising
            campaigns, or preparing and sharing aggregate reports. We may
            disclose information that individually identifies our customers or
            identifies customer devices in certain circumstances, such as:
          </p>

          <ul>
            <li>
              To comply with valid legal process including subpoenas, court
              orders or search warrants, and as otherwise authorized by law; To
              protect our rights or property, or the safety of our customers or
              employees;
            </li>
            <li>
              To protect against fraudulent, malicious, abusive, unauthorized or
              unlawful use of or subscription to our products and services and
              to protect our network, services, devices and users from such use;
            </li>
            <li>
              To advance or defend against complaints or legal claims in court,
              administrative proceedings and elsewhere;
            </li>
            <li>
              To a third-party that you have authorized to verify your account
              information;
            </li>
            <li>To outside auditors and regulators; or With your consent.</li>
          </ul>

          When you purchase services offered jointly by Carnival and one of our
          partners, customer information may be received by both Carnival and
          our partner that is providing your service. For these jointly offered
          services, you should also review the partner company’s privacy policy
          which may include practices that are different from the practices
          described here.
        </div>
        <br />
        <div class="row">
          <h4>Information security and data retention</h4>
          <p>
            Carnival has technical, administrative and physical safeguards in
            place to help protect against unauthorized access to, use or
            disclosure of customer information we collect or store. Employees
            are trained on the importance of protecting privacy and on the
            proper access to, use and disclosure of customer information. Under
            our practices and policies, access to sensitive personally
            identifiable information is authorized only for those who have a
            business need for such access. Personally identifiable and other
            sensitive records are retained only as long as reasonably necessary
            for business, accounting, tax or legal purposes. Although we work
            hard to protect personal information that we collect and store, no
            program is 100% secure and we cannot guarantee that our safeguards
            will prevent every unauthorized attempt to access, use or disclose
            personal information. If you become aware of a security issue,
            please contact us at
            <a href="mailto:info@carnival.com.bd">info@carnival.com.bd</a>. We
            will work with you to address any problems.
          </p>
        </div>
        <div class="row">
          <h4>Accessing and updating your information</h4>
          <p>
            You may correct inaccuracies in your information by calling a
            customer service representative or by accessing your online account
            and updating your information.
          </p>
        </div>

        <div class="row">
          <h4>Changes to the Privacy Policy</h4>
          <p>
            We reserve the right to make changes to this privacy policy, If
            Carnival elects to use or disclose information that identifies you
            as an individual in a manner that is materially different from that
            stated in our policy at the time we collected that information from
            you, we will give you a choice regarding such use or disclosure by
            appropriate means, which may include use of an opt out mechanism.
          </p>
        </div>

        <div class="row">
          <h4>Contact us</h4>
          <p>
            If you have questions, concerns or suggestions related to our
            Privacy Policy or our privacy practices you may write to us at
            <a href="mailto:info@carnival.com.bd"> info@carnival.com.bd </a>
            or Uday Tower, Level 12, 57 &#38; 57/A, Gulshan Avenue, Dhaka-1212.
          </p>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI } from "@/services/api";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "DataUsage",
  metaInfo: {
    title: "Ticket History | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    fields: {
      current_password: "",
      new_password: "",
      retype_password: "",
    },
    list: {
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
  }),
  // method is called after page load
  mounted: function () {
    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click');
    // }
    // this.api_url = '/admin_users';
    // this.getUsageData();
    // // this.getOrganization();
    // this.$root.$on('sort-data', () => {
    //   this.$root.$emit('show-icon');
    //   this.getUsageData();
    // });
  },
  methods: {
    goback() {
      this.$router.back(-1);
    },

    OpenTicket() {
      let _this = this;
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/open-ticket";
          let method = "POST";
          console.log(this.ticket);
          axios({
            method: method,
            url: api_url,
            data: _this.ticket,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.is_loading = false;
              // _this.$router.push({ name: "Users" });
            })
            .catch((errors) => {
              //alert("Error happend!");
              // console.log("Errors:::", errors);
              //console.log("Errors:::", response);
              console.log(errors.response.data);
              _this.$setErrorsFromResponse(errors.response.data);
              //   _this.$setErrorsFromResponse(errors.response.data.errors);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        } else {
          console.log("Validation failed");
        }
      });
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    getUsageData() {},

    getUsers() {},

    apiUsage(query = null) {
      return new Promise((resolve, reject) => {
        axios
          .get(this.api_url, {
            params: query,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            if (error.response.status === 403) {
              this.has_permission = false;
            }
            reject(error);
          });
      });
    },
  },
};
</script>
